import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment-timezone';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { QuestionnaireService } from "../../services/questionnaire/questionnaire.service";
import { AlertBannerService, AlertType } from "../../lib/alert-banner";
import { InsightsService } from "../../services/insights/insights.service";
import { PermissionsService } from "../../services/permissions/permissions.service";
import { InsightsFilterModalComponent } from '../../components/insights-filter-modal/insights-filter-modal.component';
import { DateRangePickerPopoverComponent } from 'src/app/lib/date-range-picker-popover/date-range-picker-popover.component';
import { RequestsPulseService } from 'src/app/services/requests/requests-pulse.service';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { SelectCheckTypeModalComponent } from 'src/app/components/select-check-type-modal/select-check-type-modal.component';
import { environment } from 'src/environments/environment';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { take } from 'rxjs/operators';
import * as Cookies from 'js-cookie';
import { AiSettingsService } from 'src/app/services/ai-settings/ai-settings.service';

@Component({
  selector: 'app-insights',
  templateUrl: './insights.component.pug',
  styleUrls: ['./insights.component.scss'],
  standalone: false
})
export class InsightsComponent implements OnInit {

  start = moment('1970-01-01T00:00:00.000');
  end = moment();
  pulseStart = moment().subtract(1, 'years');
  pulseEnd = moment();
  startStr = '';
  endStr = '';
  insightsFilterModalComponent: BsModalRef = new BsModalRef();
  dateRangePickerPopoverComponent: BsModalRef = new BsModalRef();
  selectCheckTypeModal: BsModalRef = new BsModalRef();
  filterBy = $localize`Employment end date`;
  filter = $localize`All`;
  filterOutput: any;
  questionnaire_list = [{}];
  questionnaire = '';
  pulseRequests: any = [];
  pulseRequestIds: any = [];
  allowedPulseRequestIds = new Set();
  pulseDepartments: any = [];
  pulseDepartmentIds: any = [];
  allowedPulseDepartmentIds = new Set();
  pulseSurveys: any = [];
  pulseSurveyIds: any = [];
  allowedPulseSurveyIds = new Set();
  questionnaire_loaded = false;
  response_count = -1;
  submitted_participants: any;
  pulse_response_count = -1;
  pulse_participants = 0;
  pulseRequestsExist = false;
  exitRequestExist = true;
  pulseLoaded = false;
  exitLoaded = false;
  participants_count = -1;
  pause_nps_load = true;
  show_response_count = true;
  comingSoon = $localize`Coming soon`;
  selectedTab: any;
  showFilters = false;
  noData = false;
  engageUrl: string = environment.ENGAGE_URL;
  requestFilterValue = 'All';
  departmentFilterValue = 'All';
  surveyFilterValue = 'All';
  disableDate = false;
  disableSurvey = false;
  disableRequest = false;
  disableDepartment = false;
  initialStart = moment();
  initialEnd = moment();
  state: any = {};
  departmentWarning = false;
  pulseDefaultDateFilter = 'Last 365 days'
  filterByOptions = [{'key': 'Requested date', 'value': $localize`Send date`}, {'key': 'Employment end date', 'value': $localize`Employment end date`}];
  hasPermissionToSendRequest = false;
  requestExit = false;
  requestPulse = false;
  requestCardHeading = ConstantsService.REQUEST_ACCESS_CARD.heading;
  requestCardSubHeading = ConstantsService.REQUEST_ACCESS_CARD.subHeading;
  requestCardbtnText = ConstantsService.REQUEST_ACCESS_CARD.heading;
  products = ConstantsService.rolesPermissionProducts;
  pulseAiHashId: string = '';
  pulseSummaryEnabled = false;

  constructor(
    private questionnaireService: QuestionnaireService,
    private alertList: AlertBannerService,
    private insightsService: InsightsService,
    private modalService: BsModalService,
    private permissionService: PermissionsService,
    private requestsPulseService: RequestsPulseService,
    public organisationService: OrganisationService,
    private router: Router,
    private aiSettingsService: AiSettingsService
  ) {
    this.state = this.router.getCurrentNavigation()?.extras?.state;
  }

  ngOnInit(): void {
    if (this.permissionService.hasPermission('can_view_send_request_button')) {
      this.hasPermissionToSendRequest = true;
    }
    if (!this.permissionService.hasPermission('can_view_exit_insights') &&
        !this.permissionService.hasPermission('can_view_exit_insights_with_survey_perms'))
    {
      this.requestExit = true;
    }
    if (!this.permissionService.hasPermission('can_view_pulse_insights') &&
        !this.permissionService.hasPermission('can_view_pulse_insights_with_survey_perms'))
    {
      this.requestPulse = true;
    }

    this.loadAiSettings();

    this.selectedTab = localStorage.getItem('insights-selected-tab')
    localStorage.setItem('insights-pulse-date-filter', this.pulseDefaultDateFilter)
    this.initialStart = this.pulseStart;
    this.initialEnd = this.pulseEnd;
    this.pulseStart = this.state?.pulseStart ? moment(this.state.pulseStart) : this.pulseStart;
    this.pulseEnd = this.state?.pulseEnd ? moment(this.state.pulseEnd) : this.pulseEnd;
    this.startStr = this.pulseStart.format('ll');
    this.endStr = this.pulseEnd.format('ll');
    this.selectedTab = localStorage.getItem('insights-selected-tab')
    if (this.state) {
      this.selectedTab = 'pulses';
      this.pulseRequestsExist = true;
      this.requestCardHeading = $localize`Request access to ${ConstantsService.rolesPermissionProducts.pulses} insights`
      this.openFilters();
      if(!this.requestPulse){
        this.setPulseRequestSearch();
      }
    }
    else if (this.selectedTab === 'pulses') {
      this.pulseRequestsExist = false
      this.requestCardHeading = $localize`Request access to ${ConstantsService.rolesPermissionProducts.pulses} insights`
      if(!this.requestPulse) {
        this.loadPulseResponseCount()
      } else {
        this.pulseLoaded = true;
      }

    }
    else {
      this.selectedTab = 'exits'
      this.requestCardHeading = $localize`Request access to ${ConstantsService.rolesPermissionProducts.exits} insights`
    }

    if (this.selectedTab === 'exits') {
      if(!this.requestExit) {
        this.questionnaire_loaded = true;
      }
      let filterOptions: any = localStorage.getItem('insights-filter');
      if (filterOptions) {
        this.filterOutput = JSON.parse(filterOptions);
        this.start = moment(this.filterOutput?.start_date);
        this.end = moment(this.filterOutput?.end_date);
        this.filter = this.filterOutput?.filter;
        this.filterBy = this.filterOutput?.filterBy;
      }
      if(!this.requestExit){this.loadResponseCount();}
      else{
        this.questionnaire_loaded = true;
        this.pause_nps_load = false;
      }

    }

  }

  public openEngageUrl(){
    window.open(this.engageUrl + ConstantsService.ENGAGE_UTM_URL, "_blank");
    return;
  }

  loadAiSettings(): void {
    this.aiSettingsService.getAiSettings().subscribe({
      next: (response) => {
        this.pulseSummaryEnabled = response.config?.pulse_summary ?? false;
      },
      error: () => {
        this.pulseSummaryEnabled = false;
      }
    });
  }

  checkPulseRequestsExist() {
    this.requestsPulseService.getRequestsDuplicateParams(
      '',
      20,
      1,
      '',
      '',
      true
    ).subscribe(
      (res) => {
        if (res.data?.total > 0) {
          this.pulseRequestsExist = true;
          this.loadPulseResponseCount();
        }
        else{
          this.pulseLoaded = true
        }
      });
  }

  setPulseRequestSearch() {
    if (this.state && this.state['request']) {
      const request = this.state['request'];
      this.pulseRequests.push(request);
      this.pulseRequestIds.push(request.id);
      this.requestsPulseService.getCheckPulse(
        '',
        '',
        this.pulseRequestIds
      ).subscribe(
        (res) => {
          this.requestFilterValue = request.name;
          this.setFilterFlowLogic('request');
          if (res.data) {
            this.allowedPulseDepartmentIds = new Set(res.data.map(a => a.department_id));
            this.allowedPulseDepartmentIds.delete(null);
          }
          this.disableDepartment = !this.allowedPulseDepartmentIds.size;
          this.loadPulseResponseCount();
        }
      );
    }

  }

  buildParticipantAndRequestData(): string {
    let participantText =
      this.participants_count === 0
        ? $localize`participants`
        : this.participants_count === 1
          ? $localize`participant`
          : $localize`participants`;

    let requestText =
      this.response_count === 0
        ? $localize`requests`
        : this.response_count === 1
          ? $localize`request`
          : $localize`requests`;

    return $localize`Displaying data from ${this.participants_count} ${participantText} from ${this.response_count} ${requestText}.`
  }

  loadResponseCount(): void {
    this.pause_nps_load = true;
    this.insightsService.getParticipationResponseCount(this.start, this.end, this.questionnaire, this.filterBy, this.selectedTab)
      .subscribe((response_count: any) => {
        this.response_count = response_count['count'];
        this.participants_count = response_count['participants'];
        this.pause_nps_load = false;
        this.getTotalExitParticipationResponseCount();
      }, error => {
        this.response_count = 0;
        this.pause_nps_load = false;
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
  }

  loadPulseResponseCount(): void {
    this.insightsService.getPulseParticipationResponseCount(this.pulseStart, this.pulseEnd, this.pulseSurveyIds, this.pulseDepartmentIds, this.pulseRequestIds)
      .subscribe((response_count: any) => {
      this.submitted_participants = response_count['submitted_participants']
        this.pulse_response_count = response_count['count'];
        this.pulse_participants = response_count['participants'];
        this.pulseLoaded = true;
        if (this.pulse_response_count > 0) {
          this.pulseRequestsExist = true;
        }
        if(this.pulseDepartmentIds.length && this.pulse_response_count) this.departmentWarning = true
        this.generatePulseAiHashId();
      }, error => {
        this.pulse_response_count = 0;
        this.pulseLoaded = true;
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
  }

  dateFilterUpdate(event: any) {
    this.start = event['start'];
    this.end = event['end'];
    this.filterBy = event['filterBy'];
    if(!this.requestExit){this.loadResponseCount();}
  }

  hideResponseCount() {
    this.show_response_count = false;
  }

  questionnairesSelected(searchOutput) {
    if (searchOutput.length) {
      this.questionnaire = _.cloneDeep(searchOutput);
    } else {
      this.questionnaire = '';
    }
    if((this.selectedTab === 'exits' && !this.requestExit) || (this.selectedTab === 'pulses' && !this.requestPulse)){
      this.loadResponseCount()
    }
  }

  onSelectTab(event) {
    window.scrollTo(0, 0);
    this.selectedTab = event.id;
    localStorage.setItem('insights-selected-tab', this.selectedTab)
    if (this.selectedTab === 'exits') {
      this.requestCardHeading = $localize`Request access to ${ConstantsService.rolesPermissionProducts.exits} insights`
      if(!this.requestExit){
        this.loadResponseCount();
      }
    } else if (this.selectedTab === 'pulses') {
      this.requestCardHeading = $localize`Request access to ${ConstantsService.rolesPermissionProducts.pulses} insights`
      if(!this.requestPulse){
        this.pulseRequestsExist = true;
        this.loadPulseResponseCount();
      }
      else{this.pulseLoaded = true}

    }
  }

  sendRequest() {
    this.selectCheckTypeModal = this.modalService.show(
      SelectCheckTypeModalComponent,
      Object.assign({}, { class: 'modal-dialog-centered select-reference-modal xxl-popup xxl-popup-product' }),
    );
    this.selectCheckTypeModal.content.closeBtnName = 'Close';
    this.selectCheckTypeModal.content.selectClick.pipe(take(1)).subscribe(res => {
  this.router.navigateByUrl('/request', {
    state: {
      checkType: res.data,
      template: res?.template,
    }
  });
});
  }

  openFilters() {
    this.showFilters = !this.showFilters;
  }

  initFilter(filterType) {
    if (
      (filterType === 'request' && this.disableRequest) ||
      (filterType === 'survey' && this.disableSurvey) ||
      (filterType === 'department' && this.disableDepartment) ||
      (filterType === 'date' && this.disableDate)
    ) {
      return;
    }
    let initialState = {};
    if (filterType !== 'date') {
      if (filterType === 'request') {
        initialState = {
          'filterType': 'request',
          'selectedItems': this.pulseRequests,
          'allowedItems': this.allowedPulseRequestIds,
          'start': this.pulseStart,
          'end': this.pulseEnd,
          'searchOptions': [{ label: $localize`Request`, value: 'request' }, { label: $localize`Created by`, value: "created_by" }],
          'sortOptions': [
            {
              'key': $localize`Request`,
              'value': [
                { 'label': $localize`A - Z`, 'sortString': 'request' },
                { 'label': $localize`Z - A`, 'sortString': '-request' }
              ]
            },
            {
              'key': $localize`Created by`,
              'value': [
                { 'label': $localize`A - Z`, 'sortString': 'created_by' },
                { 'label': $localize`Z - A`, 'sortString': '-created_by' }
              ]
            },
            {
              'key': $localize`Send date`,
              'value': [
                { 'label': $localize`Oldest`, 'sortString': 'send_date' },
                { 'label': $localize`Newest`, 'sortString': '-send_date' }
              ]
            },
            {
              'key': $localize`Cutoff date`,
              'value': [
                { 'label': $localize`Oldest`, 'sortString': 'cutoff_date' },
                { 'label': $localize`Newest`, 'sortString': '-cutoff_date' }
              ]
            },
          ],
        };
      } else if (filterType === 'department') {
        initialState = {
          'filterType': 'department',
          'selectedItems': this.pulseDepartments,
          'allowedItems': this.allowedPulseDepartmentIds,
          'start': this.pulseStart,
          'end': this.pulseEnd,
          'selectedSurveyIds': this.pulseSurveyIds,
          'searchOptions': [{ label: $localize`Department`, value: 'department' }, { label: $localize`Category`, value: "category_name" }],
          'sortOptions': [
            {
              'key': $localize`Department`,
              'value': [
                { 'label': $localize`A - Z`, 'sortString': 'department' },
                { 'label': $localize`Z - A`, 'sortString': '-department' }
              ]
            },
            {
              'key': 'group-end',
              'value': []
            },
            {
              'key': $localize`Department category`,
              'value': [
                { 'label': $localize`A - Z`, 'sortString': 'category' },
                { 'label': $localize`Z - A`, 'sortString': '-category' }
              ]
            },
          ],
        };
      } else if (filterType === 'survey') {
        initialState = {
          'filterType': 'survey',
          'selectedItems': this.pulseSurveys,
          'allowedItems': this.allowedPulseSurveyIds,
          'start': this.pulseStart,
          'end': this.pulseEnd,
          'selectedDepartmentIds': this.pulseDepartmentIds,
          'searchOptions': [{ label: $localize`Survey title`, value: 'title' }, { label: $localize`Created by`, value: "name" }],
          'sortOptions': [
            {
              'key': $localize`Survey title`,
              'value': [
                { 'label': $localize`A - Z`, 'sortString': 'title' },
                { 'label': $localize`Z - A`, 'sortString': '-title' }
              ]
            },
            {
              'key': $localize`Created by`,
              'value': [
                { 'label': $localize`A - Z`, 'sortString': 'name' },
                { 'label': $localize`Z - A`, 'sortString': '-name' }
              ]
            },
            {
              'key': $localize`Created date`,
              'value': [
                { 'label': $localize`Oldest`, 'sortString': 'created' },
                { 'label': $localize`Newest`, 'sortString': '-created' }
              ]
            },
            {
              'key': $localize`Last used`,
              'value': [
                { 'label': $localize`Oldest`, 'sortString': 'last_used' },
                { 'label': $localize`Newest`, 'sortString': '-last_used' }
              ]
            },
            {
              'key': $localize`Times used`,
              'value': [
                { 'label': $localize`Ascending`, 'sortString': 'count' },
                { 'label': $localize`Descending`, 'sortString': '-count' }
              ]
            },
          ],
        };
      }
      this.openFilterModal(filterType, initialState);
    } else {
      initialState = {
        'filterType': 'date',
        'popup': true,
        'start': this.pulseStart,
        'end': this.pulseEnd,
        'filter':
           localStorage.getItem('insights-pulse-date-filter')
      };
      this.dateRangePickerPopoverComponent = this.modalService.show(
        DateRangePickerPopoverComponent,
        { class: 'modal-dialog-centered s-popup', initialState },
      )
      this.dateRangePickerPopoverComponent.content.filterChange.subscribe(res => {
        localStorage.setItem('insights-pulse-date-filter', res.filter)
        this.pulseLoaded = false;
        this.pulseStart = res['start'];
        this.startStr = this.pulseStart.format('ll');
        this.pulseEnd = res['end'];
        this.endStr = this.pulseEnd.format('ll');
        this.generatePulseAiHashId();

        this.requestsPulseService.getCheckPulse(
          this.pulseSurveyIds,
          this.pulseDepartmentIds,
          '',
          this.pulseStart,
          this.pulseEnd
        ).subscribe(
          (res) => {
            this.setFilterFlowLogic('date');
            this.allowedPulseDepartmentIds = new Set(res.data.map(a => a.department_id));
            this.allowedPulseDepartmentIds.delete(null);
            this.allowedPulseSurveyIds = new Set(res.data.map(a => a.questionnaire_id));
            this.allowedPulseSurveyIds.delete(null);
            this.loadPulseResponseCount();
            this.disableSurvey = !this.allowedPulseSurveyIds.size;
            this.disableDepartment = !this.allowedPulseDepartmentIds.size;
            this.pulseLoaded = true;
          });
      });
      this.dateRangePickerPopoverComponent.content.hide.subscribe(res => {
        this.dateRangePickerPopoverComponent.hide()
      })
    }
  }

  openFilterModal(filterType, initialState) {
    this.insightsFilterModalComponent = this.modalService.show(
      InsightsFilterModalComponent,
      { class: 'modal-dialog-centered xl-popup', initialState },
    )
    this.insightsFilterModalComponent.content.applyFilter.subscribe(res => {
      this.departmentWarning = false;
      if (filterType === 'request') {
        this.pulseRequests = res;
        this.pulseRequestIds = res.map(i => i.id);
      } else if (filterType === 'department') {
        this.pulseDepartments = res;
        this.pulseDepartments = [...this.pulseDepartments]
        this.pulseDepartmentIds = res.map(i => i.id);
      } else if (filterType === 'survey') {
        this.pulseSurveys = res;
        this.pulseSurveyIds = res.map(i => i.questionnaire.id);
      }
      this.setFilterFlowLogic(filterType);
      this.generatePulseAiHashId();
    });
    this.insightsFilterModalComponent.content.setLastSelected.subscribe(res => {
      if (filterType === 'request') {
        this.requestFilterValue = res;
      } else if (filterType === 'department') {
        this.departmentFilterValue = res;
      } else if (filterType === 'survey') {
        this.surveyFilterValue = res;
      }
    });
    this.insightsFilterModalComponent.content.setAllowedItems.subscribe(res => {
      if (filterType === 'request') {
        this.allowedPulseDepartmentIds = new Set(res.map(a => a.department_id));
        this.allowedPulseDepartmentIds.delete(null);
        this.disableDepartment = !this.allowedPulseDepartmentIds.size;
      } else if (filterType === 'department') {
        if (!this.disableRequest) {
          this.allowedPulseRequestIds = new Set(res.map(a => a.omni_check_id));
          this.allowedPulseRequestIds.delete(null);
          this.disableRequest = !this.allowedPulseRequestIds.size;
        }
        if (!this.disableSurvey && !this.disableDate) {
          this.allowedPulseSurveyIds = new Set(res.map(a => a.questionnaire_id));
          this.allowedPulseSurveyIds.delete(null);
          this.disableSurvey = !this.allowedPulseSurveyIds.size;
        }
      } else if (filterType === 'survey') {
        this.allowedPulseDepartmentIds = new Set(res.map(a => a.department_id));
        this.allowedPulseDepartmentIds.delete(null);
        this.disableDepartment = !this.allowedPulseDepartmentIds.size;
      }
      this.loadPulseResponseCount();
    });
    this.insightsFilterModalComponent.content.refreshData.subscribe(res => {
      this.clearFilters();
    });
  }

  setFilterFlowLogic(filterType) {
    if (filterType === 'request') {
      this.disableSurvey = !!this.pulseRequests.length;
      this.disableDate = !!this.pulseRequests.length;
      if (this.pulseRequests.length) {
        const createdDates = this.pulseRequests.map(r => moment(r.created));
        const expiryDates = this.pulseRequests.map(r => moment(r.expiry || r.created));
        this.pulseStart = moment.min(createdDates);
        this.pulseEnd = moment.max(expiryDates);
        this.startStr = this.pulseStart.format('ll');
        this.endStr = this.pulseEnd.format('ll');
      }
    } else if (filterType === 'survey') {
      this.disableRequest = !!this.pulseSurveys.length;
    } else if (filterType === 'date') {
      this.disableRequest = this.pulseStart !== this.initialStart || this.pulseEnd !== this.initialEnd;
    }
  }

  clearFilters() {
    this.disableRequest = false;
    this.disableSurvey = false;
    this.disableDepartment = false;
    this.disableDate = false;
    this.departmentWarning = false;

    this.requestFilterValue = 'All';
    this.surveyFilterValue = 'All';
    this.departmentFilterValue = 'All';
    this.pulseStart = this.initialStart;
    this.pulseEnd = this.initialEnd;
    this.startStr = this.pulseStart.format('ll');
    this.endStr = this.pulseEnd.format('ll');
    this.allowedPulseRequestIds = new Set();
    this.allowedPulseDepartmentIds = new Set();
    this.allowedPulseSurveyIds = new Set();
    localStorage.setItem("insights-pulse-date-filter", this.pulseDefaultDateFilter);

    this.pulseRequestIds = [];
    this.pulseSurveyIds = [];
    this.pulseDepartmentIds = [];

    this.pulseDepartments = [];
    this.pulseSurveys = [];
    this.pulseRequests = [];
    this.loadPulseResponseCount();
    this.generatePulseAiHashId();
  }

 /**
 * Retrieves the total participation and response count if both response_count and participants_count are zero.
 * This function is used to check the existence of any exit request
 */
  getTotalExitParticipationResponseCount(){
    if(this.response_count == 0 && this.participants_count == 0){
      const exitStart = moment('1970-01-01T00:00:00.000');
      const exitEND = moment();
      const exitQuestionnaire = '';
      const exitFilterBy = "Employment end date";
      const exitSelectedTab = "exits";

      this.insightsService.getParticipationResponseCount(exitStart, exitEND, exitQuestionnaire, exitFilterBy, exitSelectedTab)
      .subscribe({
        next: (response_count:any) => {
          this.exitLoaded = true;
          this.exitRequestExist = !!(response_count['count'] || response_count['participants']);
        },
        error: (err:any) => {
          console.log(err)
        }
      })
    } else {
      this.exitLoaded = true;
    }
  }

  onRequestAccess($:any, product: string){
    this.permissionService.requestAccess(
      {
        product: product,
        template_type: 'hybrid'
      }
    ).subscribe(
      (res) => {
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Your request has been sent successfully. You will be notified once your request has been approved.`,
          keepOnRouteChange: true
        }]);
        this.requestExit = true;
      },
      (error) => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    )
  }

  /**
   * Generate a hash ID for the Pulse AI summary based on current filters.
   * This hash is used to identify unique filter combinations for caching.
   * Format: {user_uid}-{filter_hash}
   */
  generatePulseAiHashId(): string {
    // Get user UID from cookie
    const userUid = Cookies.get('user_uid') || '';

    // Generate hash from filters only
    const filterData = {
      request: !this.disableRequest ? this.pulseRequestIds : [],
      survey: !this.disableSurvey ? this.pulseSurveyIds : [],
      department: !this.disableDepartment ? this.pulseDepartmentIds : [],
      start: this.pulseStart ? this.pulseStart.format('YYYY-MM-DD') : '',
      end: this.pulseEnd ? this.pulseEnd.format('YYYY-MM-DD') : ''
    };

    // Simple hash function
    const str = JSON.stringify(filterData);
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    const filterHash = Math.abs(hash).toString(16);

    // Return format: user_uid-filter_hash
    this.pulseAiHashId = userUid ? `${userUid}-${filterHash}` : filterHash;
    return this.pulseAiHashId;
  }

}
